module.exports = __webpack_public_path__ + "img/IMG-20200308-WA0211.874ff27f.jpg";